export default __webpack_public_path__ + "static/media/Montserrat-ExtraBold.3a9ee100.ttf";